export interface Special {
  id: string;
  title: string;
  cover: string;
  intro: string;
  editorNote: string;
  movieIds: string[];
}

export const specials: Special[] = [
  {
    id: 'autumn-drama',
    title: '秋日新剧精选',
    cover: 'https://readdy.ai/api/search-image?query=Panoramic%20editorial%20banner%20of%20a%20cozy%20autumn%20city%20skyline%20at%20dusk%20with%20warm%20amber%20windows%20and%20deep%20blue%20evening%20sky%2C%20cinematic%20moody%20grading%2C%20wide%20open%20composition%20with%20copy%20space%2C%20high%20detail%20art%20direction&width=1200&height=600&seq=mmv-special-01&orientation=landscape',
    intro: '当夜色渐长，适合窝在沙发里慢慢追一部剧。本期专题为你挑选了本季口碑与热度兼具的剧集，从古装传奇到都市群像，总有一部能陪你度过整个秋天。',
    editorNote: '编辑点评：这一季的剧集在叙事节奏上更从容，人物塑造也更细腻，特别推荐《山海拾遗》与《城市褶皱》。',
    movieIds: ['4', '5', '16', '20', '2'],
  },
  {
    id: 'sci-fi-vision',
    title: '科幻视界',
    cover: 'https://readdy.ai/api/search-image?query=Wide%20sci-fi%20banner%20of%20a%20futuristic%20city%20skyline%20with%20glowing%20data%20streams%20and%20a%20deep%20blue%20starfield%2C%20electric%20orange%20accents%20and%20atmospheric%20fog%2C%20epic%20cinematic%20scale%2C%20clean%20composition%20with%20copy%20space%2C%20high%20detail%20key%20art&width=1200&height=600&seq=mmv-special-02&orientation=landscape',
    intro: '从深海沟壑到数据洪流，从机械之心到玻璃森林。科幻的魅力，在于用想象丈量世界的边界。本期专题带你走进五个截然不同的未来叙事。',
    editorNote: '编辑点评：科幻不只是特效，更是对人与技术关系的追问。这几部作品在设定之外，都保留了足够的人情味。',
    movieIds: ['1', '7', '11', '21', '24'],
  },
  {
    id: 'healing-anime',
    title: '治愈系动漫时光',
    cover: 'https://readdy.ai/api/search-image?query=Soft%20pastel%20anime%20banner%20of%20rolling%20green%20hills%20and%20clouds%20under%20a%20clear%20gentle%20sky%2C%20warm%20golden%20sunlight%20with%20calm%20blue%20tones%2C%20peaceful%20serene%20atmosphere%2C%20wide%20minimal%20composition%20with%20copy%20space%2C%20high%20detail%20illustration&width=1200&height=600&seq=mmv-special-03&orientation=landscape',
    intro: '有时候，故事不需要跌宕起伏，只需要一份恰到好处的温柔。本期专题精选画面与情绪都格外治愈的动画作品，献给每一个想慢下来的你。',
    editorNote: '编辑点评：慢节奏不等于没张力，这些作品用日常的细节，把温暖一点点递到观众心里。',
    movieIds: ['12', '17', '24', '11'],
  },
  {
    id: 'mystery-season',
    title: '悬疑推理季',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20banner%20of%20a%20foggy%20night%20street%20with%20a%20single%20glowing%20streetlight%20and%20long%20shadows%2C%20cold%20navy%20blue%20with%20amber%20highlights%2C%20tense%20noir%20cinematic%20atmosphere%2C%20wide%20composition%20with%20copy%20space%2C%20high%20detail%20art%20direction&width=1200&height=600&seq=mmv-special-04&orientation=landscape',
    intro: '真相往往藏在最不起眼的细节里。本期专题集结了几部结构精巧的悬疑作品，从雨夜小镇到玻璃森林，层层反转，直到最后一刻才肯揭晓答案。',
    editorNote: '编辑点评：好的悬疑让人猜不到结局，更好的悬疑让人舍不得快进。这份片单，建议关灯静看。',
    movieIds: ['2', '3', '8', '14', '19'],
  },
];

export const specialDisclaimer = '专题为编辑策划演示内容，影视资料均为虚构示例。';